import { jsonCopy } from '../../../utility/genericUtility';
import { datiGeneraliInizializzato, datiResidenzaInizializzato, datiAntiriciclaggioInizializzato, datiAttEconomicaInizializzato, datiRelazContrInizializzato } 
	from '../componentiBase/sezioniAnagrafica';

export const datiGenerali = jsonCopy(datiGeneraliInizializzato);
export const datiResidenza = jsonCopy(datiResidenzaInizializzato);
export const datiAntiriciclaggio = jsonCopy(datiAntiriciclaggioInizializzato);
export const datiAttEconomica = jsonCopy(datiAttEconomicaInizializzato);
export const datiRelazContr = jsonCopy(datiRelazContrInizializzato)
